import { Box, styled, Tab, Typography } from "@mui/material"

export const GroupDetailsRegion = styled(Box)({
  width: "300px",
  height: "100%",
  borderRight: "1px solid #E3E3E3",
  // border: "1px solid red"
})

export const GroupDetailsGroupName = styled(Box)({
  fontSize: "14px",
  color: "#000000",
  fontWeight: "900",
  padding: " 16px 29px",
})

export const GroupDetailsRegionWrapper = styled(Box)({
  backgroundColor: "#F7F7F7",
})

export const GroupDetailsRegionHeading = styled(Box)({
  color: "#6F7070",
  fontSize: "12px",
  padding: "16px 30px",
})

export const GroupDetailsRegionList = styled(Box)({
  padding: "16px 30px",
  display: "flex",
  justifyContent: "space-between",
  fontSize: "14px",
})

export const RoleIdText = styled(Typography)({
  display: "block",
  color: "#6F7070",
  fontSize: "12px",
})
